import React, { useState } from "react";
import { ThemeProvider } from "@mui/material";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import { TabContext, TabList, TabPanel } from "@mui/lab";
import SDLComponent from "./SDLComponent";
import NonSDLComponent from "./NonSDLComponent";

const ToolsComponent = (props) => {
    const [value, setValue] = useState("1");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const containerStyle = {
        backgroundColor: props.activeTheme.palette.mode === "dark" ? "#1a1a1a" : "#fafafa",
        color: props.activeTheme.palette.mode === "dark" ? "#fff" : "#000",
        width: "100%",
        minHeight: "100vh",
    };

    const infoCardStyle = {
        p: 2,
        mb: 3,
        backgroundColor: props.activeTheme.palette.mode === "dark" ? "#252525" : "#fff",
        borderRadius: 1,
        border: `1px solid ${props.activeTheme.palette.mode === "dark" ? "#333" : "#e0e0e0"}`,
    };

    return (
        <ThemeProvider theme={props.activeTheme}>
            <Box style={containerStyle}>
                <TabContext value={value}>
                    <Box sx={{ display: "flex", minHeight: "100vh" }}>
                        {/* Sidebar Navigation */}
                        <Box sx={{
                            borderRight: 1,
                            borderColor: props.activeTheme.palette.mode === "dark" ? "#333" : "#e0e0e0",
                            backgroundColor: props.activeTheme.palette.mode === "dark" ? "#1a1a1a" : "#fff",
                            minWidth: 220,
                            maxWidth: 220,
                        }}>
                            <TabList 
                                orientation="vertical"
                                onChange={handleChange} 
                                sx={{
                                    pt: 2,
                                    "& .MuiTab-root": {
                                        textTransform: "none",
                                        fontWeight: 500,
                                        alignItems: "flex-start",
                                        textAlign: "left",
                                        px: 3,
                                        py: 1.5,
                                        minHeight: "auto",
                                    },
                                    "& .MuiTab-root.Mui-selected": {
                                        color: props.activeTheme.palette.primary.main,
                                        backgroundColor: props.activeTheme.palette.mode === "dark" ? "#252525" : "#f5f5f5",
                                    },
                                }}
                            >
                                <Tab label="SDL" value="1"/>
                                <Tab label="NON-SDL" value="2"/>
                            </TabList>
                        </Box>

                        {/* Main Content Area */}
                        <Box sx={{ flex: 1, overflow: "auto" }}>
                            {/* SDL Panel */}
                            <TabPanel value="1" sx={{ px: 0, py: 0 }}>
                                <SDLComponent activeTheme={props.activeTheme} infoCardStyle={infoCardStyle} />
                            </TabPanel>

                            {/* NON-SDL Panel */}
                            <TabPanel value="2" sx={{ px: 0, py: 0 }}>
                                <NonSDLComponent activeTheme={props.activeTheme} infoCardStyle={infoCardStyle} />
                            </TabPanel>
                        </Box>
                    </Box>
                </TabContext>
            </Box>
        </ThemeProvider>
    );
};

export default ToolsComponent;
